"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _header = _interopRequireDefault(require("../header"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DestinationUrlView = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(DestinationUrlView, _Component);

  var _super = _createSuper(DestinationUrlView);

  function DestinationUrlView() {
    (0, _classCallCheck2.default)(this, DestinationUrlView);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(DestinationUrlView, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          destinationURL = _this$props.destinationURL,
          onNavigateToEdit = _this$props.onNavigateToEdit;
      return (0, _preact.h)("div", {
        className: "community-settings-page"
      }, (0, _preact.h)(_header.default, {
        title: "Destination URL",
        isBeta: true,
        disableCancelButton: true,
        disableSaveButton: true
      }), (0, _preact.h)("div", {
        className: "community-settings"
      }, (0, _preact.h)("div", {
        className: "destination-url-view"
      }, (0, _preact.h)("div", {
        className: "destination-url-section"
      }, (0, _preact.h)("div", {
        className: "destination-url-header"
      }, (0, _preact.h)("h3", {
        className: "destination-url-title"
      }, "Destination Custom URL"), (0, _preact.h)("p", {
        className: "destination-url-description"
      }, "This is the live destination URL where your Customer Community is accessible. You can update it at any time by pointing a new domain and configuring the DNS settings accordingly.")), (0, _preact.h)("div", {
        className: "url-display-container"
      }, (0, _preact.h)("div", {
        className: "url-field"
      }, (0, _preact.h)("span", {
        className: "url-text"
      }, destinationURL)), (0, _preact.h)("button", {
        type: "button",
        onClick: function onClick() {
          return window.open(destinationURL, '_blank');
        },
        className: "external-link-button",
        "aria-label": "Open ".concat(destinationURL, " in new tab"),
        title: "Open ".concat(destinationURL, " in new tab")
      }, (0, _preact.h)(_assets.default, {
        icon: "externalLink",
        customClass: "external-link-icon"
      }))), (0, _preact.h)("div", {
        className: "status-table"
      }, (0, _preact.h)("div", {
        className: "status-row status-header"
      }, (0, _preact.h)("div", {
        className: "status-cell"
      }, "STATUS"), (0, _preact.h)("div", {
        className: "status-cell"
      }, "DNS STATUS"), (0, _preact.h)("div", {
        className: "status-cell"
      }, "SSL STATUS")), (0, _preact.h)("div", {
        className: "status-row status-values"
      }, (0, _preact.h)("div", {
        className: "status-cell"
      }, (0, _preact.h)("div", {
        className: "status-value-item"
      }, (0, _preact.h)("div", {
        className: "status-icon-frame"
      }, (0, _preact.h)(_assets.default, {
        icon: "checkInCircle",
        customClass: "status-icon"
      })), (0, _preact.h)("span", {
        className: "text-body"
      }, "Active"))), (0, _preact.h)("div", {
        className: "status-cell"
      }, (0, _preact.h)("span", {
        className: "text-body"
      }, "Verified")), (0, _preact.h)("div", {
        className: "status-cell"
      }, (0, _preact.h)("span", {
        className: "text-body"
      }, "Active"))))), (0, _preact.h)("div", {
        className: "update-section"
      }, (0, _preact.h)("div", {
        className: "update-section-left"
      }, (0, _preact.h)("div", {
        className: "update-title-container"
      }, (0, _preact.h)("h4", {
        className: "update-title"
      }, "Update Destination URL")), (0, _preact.h)("div", {
        className: "update-description-container"
      }, (0, _preact.h)("p", {
        className: "update-warning"
      }, "Changing the destination URL will require DNS reconfiguration and may cause temporary downtime."))), (0, _preact.h)("div", {
        className: "update-section-right"
      }, (0, _preact.h)(_Button.default, {
        title: "Change URL",
        variant: "secondary",
        onClick: onNavigateToEdit,
        size: "medium"
      }))))));
    }
  }]);
  return DestinationUrlView;
}(_preact.Component);

var _default = DestinationUrlView;
exports.default = _default;